<article class="lines-container">
  <canvas
    baseChart
    class="chart"
    [type]="chartType"
    [data]="data"
    [options]="lineChartOptions"
    (chartClick)="onChartClick($event)"
  ></canvas>
</article>
